import { FC } from 'react'

import { Box, Breadcrumbs, Link } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useTranslation } from 'react-i18next'
import { IlocationData } from '../../API/types'
import { useGetControllers, useGetLocationsById, useGetRoomTypes } from '../../API'
import { useLocation } from 'react-router-dom'
import { RoomsInfo, RoomsListTable } from '../../components'

const useStyles = makeStyles()(({ spacing }) => ({
  box: {
    margin: spacing(0.5),
  },
}))

const RoomsList: FC = () => {
  const { t } = useTranslation('')
  const { classes } = useStyles()

  const rootLocationId = useLocation().pathname.split('/')[2] || '0'

  const locationData = useGetLocationsById(rootLocationId)
  const controllers = useGetControllers()
  const roomTypesData = useGetRoomTypes()

  return (
    <>
      <Box
        sx={
          {
            //display: 'flex',
            //flexWrap: 'wrap',
            //maxWidth: 300,
          }
        }
      >
        <Box className={classes.box}>
          <Breadcrumbs aria-label='breadcrumb'>
            <Link underline='hover' color='inherit' href='/roomsList'>
              {t('Lokācijas')}
            </Link>
            {locationData?.currentLocation.map((location: IlocationData) => (
              <Link key={`id-${location.id}`} underline='hover' color='inherit' href={`/roomsList/${location.id}`}>
                {location.locationName}
              </Link>
            ))}
          </Breadcrumbs>
        </Box>

        {locationData?.collection.map((location: IlocationData) => (
          <Box className={classes.box} key={`box-${location.id}`}>
            <RoomsInfo location={location} controllers={controllers} roomTypesData={roomTypesData} />
          </Box>
        ))}
        <Box className={classes.box}>
          {locationData && (
            <RoomsListTable locationData={locationData} controllers={controllers} roomTypesData={roomTypesData} />
          )}
        </Box>
      </Box>
    </>
  )
}

export default RoomsList
